// Generated by Melange

import * as Buhta_cabinet__PageNav from "../../../molecules/PageNav.js";
import * as Buhta_cabinet__Table2 from "../../../molecules/Table/Table2.js";
import * as Cn from "../../../../../../../vendored/classnames/Cn.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function Contracts(Props) {
  let viewContract = Props.viewContract;
  const match = React.useState(function () {
    return 1;
  });
  const cells = viewContract ? ({
      hd: {
        body: "ЧК-BUHTA-01",
        style: ""
      },
      tl: {
        hd: {
          body: "Создан",
          style: "justify-end col-span-2"
        },
        tl: /* [] */ 0
      }
    }) : ({
      hd: {
        body: "ЧК-BUHTA-01",
        style: ""
      },
      tl: {
        hd: {
          body: "Входящий",
          style: ""
        },
        tl: {
          hd: {
            body: "Разработка дизайна приложения для iOS и Android",
            style: "col-span-2"
          },
          tl: {
            hd: {
              body: "ТОО \"PS Engineering\"",
              style: "col-span-2"
            },
            tl: {
              hd: {
                body: "10 000",
                style: "justify-end lg:pr-6"
              },
              tl: {
                hd: {
                  body: "Создан",
                  style: ""
                },
                tl: {
                  hd: {
                    body: "15.09.2022",
                    style: "justify-end"
                  },
                  tl: /* [] */ 0
                }
              }
            }
          }
        }
      }
    });
  const rows_0 = JsxRuntime.jsx(Buhta_cabinet__Table2.Row.make, {
    cells: cells,
    route: {
      TAG: /* Org */ 6,
      _0: 1,
      _1: {
        TAG: /* Documents */ 1,
        _0: {
          TAG: /* Contracts */ 0,
          _0: {
            TAG: /* View */ 0,
            _0: 1
          }
        }
      }
    }
  });
  const rows = {
    hd: rows_0,
    tl: /* [] */ 0
  };
  const header = viewContract ? ({
      hd: {
        name: "Наименование договора",
        style: "col-span-2"
      },
      tl: {
        hd: {
          name: "Статус",
          style: "justify-end text-right"
        },
        tl: /* [] */ 0
      }
    }) : ({
      hd: {
        name: "№ договора",
        style: ""
      },
      tl: {
        hd: {
          name: "Направление",
          style: ""
        },
        tl: {
          hd: {
            name: "Наименование договора",
            style: "col-span-2"
          },
          tl: {
            hd: {
              name: "Контрагент",
              style: "col-span-2"
            },
            tl: {
              hd: {
                name: "Сумма",
                style: " text-right lg:pr-6"
              },
              tl: {
                hd: {
                  name: "Статус",
                  style: ""
                },
                tl: {
                  hd: {
                    name: "Дата договора",
                    style: "text-right pr-6"
                  },
                  tl: /* [] */ 0
                }
              }
            }
          }
        }
      }
    });
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Buhta_cabinet__Table2.make, {
          header: header,
          rows: rows,
          styles: Cn.$plus(Cn.on("grid-cols-9", !viewContract), Cn.on("grid-cols-3", viewContract))
        }),
        className: "flex-1 overflow-auto"
      }),
      JsxRuntime.jsx(Buhta_cabinet__PageNav.make, {
        page: match[0],
        setPage: match[1],
        currentRecords: 1
      })
    ],
    className: "flex flex-col w-full"
  });
}

const make = Contracts;

export {
  make,
}
/* Buhta_cabinet__PageNav Not a pure module */
